export const plans = [
  // {
  //   title: "Basic",
  //   Duration: "3-7 days",
  //   price: "$100-$1,000",
  //   min: "100",
  // },
  {
    title: "Bronze",
    // Duration: "24Hrs",
    price: "$1,000-$5,000",
    min: "5000",
    roi: "60%",
  },
  {
    title: "Silver",
    // Duration: "48Hrs",
    price: "$5,000-$10,000",
    min: "10000",
    roi: "65%",
  },
  {
    title: "Gold",
    // Duration: "72Hrs",
    price: "$10,000-$100,000",
    min: "100000",
    roi: "75%",
  },
  {
    title: "Platinum",
    // Duration: "7-14days",
    price: "$100,000-$1,000,000",
    min: "1000000",
    roi: "100%",
  },
];
